"use client";
import Cookies from "js-cookie";
import { usePathname, useRouter } from "next/navigation";
import { useState, useEffect } from "react";

const languageNames = {
  az: "az",
  en: "en",
  ru: "ru",
};
const Lang = () => {
  const pathname = usePathname();
  const router = useRouter();
  const CurrentLocale = Cookies.get("NEXT_LOCALE") || "az";
  const [language, setLanguage] = useState(
    languageNames[CurrentLocale] || "az"
  );

  const ChangeLang = (lang) => {
    Cookies.set("NEXT_LOCALE", lang);
    const segments = pathname.split("/");
    segments[1] = lang; // Replace the first segment with the new locale

    router.push(segments.join("/"));
    setTimeout(() => {
      router.refresh();
    }, 100);
  };

  useEffect(() => {
    if (CurrentLocale) {
      setLanguage(languageNames[CurrentLocale] || "az");
    }
  }, [pathname, CurrentLocale]);

  return (
    <div className="lang">
      {language !== "az" && (
        <button type="button" onClick={() => ChangeLang("az")}>
          AZ
        </button>
      )}

      {language !== "en" && (
        <button type="button" onClick={() => ChangeLang("en")}>
          EN
        </button>
      )}

      {language !== "ru" && (
        <button type="button" onClick={() => ChangeLang("ru")}>
          RU
        </button>
      )}
    </div>
  );
};

export default Lang;
